/**
 * Alcance efectivo de una tabla (empresa o sucursal) para el usuario y la
 * consulta base por ese alcance. Módulo liviano (solo tipos de importación):
 * lo usan las reglas de filtro de las tablas, que el catálogo de
 * configuración importa y que también llega a los clientes (web y móvil) por
 * `convex/lib/modules`; `with_filtering_data.ts` lo re-exporta.
 */
import type { Id, TableNames } from "../../../_generated/dataModel";
import type { QueryCtx } from "../../../_generated/server";
import type { UserContext } from "../../../system/context";
import type { TableScope } from "../../config/types";

/**
 * Resuelve el scope efectivo para una tabla. Si la tabla es masterData
 * (clientes, productos, servicios) y el usuario tiene `masterDataScope`
 * dinamico en la empresa, ese flag tiene prioridad sobre el `scope`
 * estatico de la config:
 *   - masterDataScope === "branch" + usuario no super_admin + branchId -> "branch"
 *   - cualquier otro caso -> scope estatico (o "company" por default)
 */
export function resolveEffectiveScope(
  tableConfig: { scope?: TableScope; masterData?: boolean },
  userContext: UserContext,
): TableScope {
  if (tableConfig.masterData === true) {
    if (
      userContext.masterDataScope === "branch" &&
      userContext.isSuperAdmin !== true &&
      Boolean(userContext.branchId)
    ) {
      return "branch";
    }
    return "company";
  }
  return tableConfig.scope ?? "company";
}

export function getBaseQuery(
  ctx: QueryCtx,
  tableName: TableNames,
  companyId: Id<"companies">,
  branchId?: Id<"branches">,
  scope?: TableScope,
) {
  if (scope === "branch" && branchId) {
    return (ctx.db.query(tableName) as any).withIndex(
      "by_company_and_branch",
      (q: any) =>
        q
          .eq("internalControl.companyId", companyId)
          .eq("internalControl.branchId", branchId),
    );
  }
  return (ctx.db.query(tableName) as any).withIndex("by_company_id", (q: any) =>
    q.eq("internalControl.companyId", companyId),
  );
}
